<template>
  <Section>
    <template v-slot:section-header>
      <h5 class="title">รายละเอียด</h5>
    </template>
    <template v-slot:section-body>
      <form>
        <div class="row">
          <div class="col-md-8">
            <FormGroup
              class="with-help-text"
              :errorMessage="getErrorMessage('tagline')">
              <h5 class="name">รายละเอียดอย่างสั้น</h5>
              <small class="help-text">
                คำอธิบายสั้นๆ ที่จะถูกใช้ในการแสดงตัวอย่างใน เสิร์ชเอ็นจิ้นและโซเชียลเน็ทเวิร์ค
              </small>
              <textarea
                type="text"
                rows="5"
                class="form-control"
                :class="{'is-invalid': getErrorMessage('tagline')}"
                placeholder="รายละเอียดอย่างสั้น"
                :disabled="currentVideo.isUsingEpisodeMetadata"
                :value="currentVideo.tagline"
                @input="$store.dispatch('setCurrentVideo', { tagline: $event.target.value })" />
            </FormGroup>
            <FormGroup>
              <h5 class="name">คำอธิบาย</h5>
              <HtmlEditor
                :description="currentVideo.description"
                :editable="!currentVideo.isUsingEpisodeMetadata"
                @update:description="(description) => $store.dispatch('setCurrentVideo', { description })"/>
            </FormGroup>
          </div>
          <div class="col-md-4">
            <FormGroup>
              <h5 class="name">แท็ก</h5>
              <multiselect
                :disabled="currentVideo.isUsingEpisodeMetadata"
                :value="currentVideo.tags"
                :options="tags"
                :taggable="true"
                :multiple="true"
                :addTag="addTag"
              	@onSearch="loadTags"
                @onChanged="(tags) => $store.dispatch('setCurrentVideo', { tags })" />
            </FormGroup>
            <FormGroup>
              <ManageCollectionItem class="d-inline"
                :itemId="currentVideo.id"
                :collectionType="'video'">
                เพิ่มวีดีโอลงเพลย์ลิสต์
              </ManageCollectionItem>
            </FormGroup>
          </div>
        </div>
      </form>
    </template>
  </Section>
</template>

<script>
import _ from 'lodash';
import { mapState } from 'vuex';
import { loadTaxonomyByKey } from '@/taxonomy/api';
import Multiselect from '@/components/MultiSelect.vue';
import FormGroup from '@/components/FormGroup.vue';
import Section from '@/components/Section.vue';
import HtmlEditor from '@/htmlEditor/HtmlEditor.vue';
import ManageCollectionItem from '@/collection/ManageCollectionItem.vue';

export default {
  props: {
    saveVideoStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Multiselect,
    FormGroup,
    Section,
    HtmlEditor,
    ManageCollectionItem,
  },
  data() {
    return {
      tags: [],
    };
  },
  created() {
    this.loadTags();
  },
  computed: {
    ...mapState({
      currentVideo: (state) => state.videoItem.currentVideo,
      saveVideoState: (state) => state.videoItem.saveVideoState,
    }),
  },
  methods: {
    async loadTags(filter) {
      const response = await loadTaxonomyByKey('tag', filter);
      this.tags = response.data.data;
    },
    addTag(tag) {
      this.tags.push(tag);
      this.$store.dispatch('setCurrentVideo', { tags: [...this.currentVideo.tags, tag] });
    },
    getErrorMessage(fieldName) {
      return _.get(this.saveVideoState.error, `${fieldName}`, null);
    },
  },
};
</script>

<style lang="scss" scoped>
@import './src/assets/scss/variables.scss';
@import './src/assets/scss/themes/components/form.scss';
@import './src/assets/scss/themes/components/section-container.scss';
</style>
